// All url settings for sub-program maps

export const cropInsuranceMapIdByChecked: Record<string, string> = {
    "0": "net-farmer-benefits",
    "01": "farmer-paid-premium",
    "00": "total-indemnities",
    "02": "total-premium",
    "03": "premium-subsidy",
    "1": "loss-ratio",
    "2": "average-liabilities",
    "3": "policies-earning-premium",
    "4": "average-insured-area"
};

export const eqipMapIdByChecked: Record<string, string> = {
    0: "total-eqip-benefits",
    1: "land-management",
    2: "forest-management",
    3: "structural",
    4: "soil-remediation",
    5: "vegetative",
    6: "other-improvements",
    7: "soil-testing",
    8: "other-planning",
    9: "conservation-planning-assessment",
    10: "resource-conserving-crop-rotation",
    11: "soil-health",
    12: "comprehensive-nutrient-mgt"
};

export const cspMapIdByChecked: Record<string, string> = {
    0: "total-csp-benefits",
    1: "2018-practices",
    2: "structural",
    3: "vegetative",
    4: "land-management",
    5: "forest-management",
    6: "soil-remediation",
    7: "existing-activity-payments",
    8: "soil-testing",
    9: "other-improvements",
    10: "2014-eligible-land",
    11: "cropland",
    12: "grassland",
    13: "rangeland",
    14: "pastureland",
    15: "nipf",
    16: "other-csp",
    17: "miscellaneous",
    18: "bundles",
    19: "6b-planning"
};

export const title1MapIdByChecked: Record<string, string> = {
    0: "total-commodities-programs",
    1: "subtitle-a-total",
    2: "arc",
    20: "arc-co",
    21: "arc-ic",
    3: "plc",
    4: "subtitle-d-dmc",
    5: "subtitle-e-total",
    50: "elap",
    51: "lfp",
    52: "lip",
    53: "tap"
};
